import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RichTextEditor from 'react-rte';

import Container from 'components/Container';

const RichTextEditorComponent = ({ onChange, defaultValue, fullWidth, marginTop }) => {
  const [richTextValue, setRichTextValue] = useState(
    RichTextEditor.createValueFromString(
      defaultValue === null || defaultValue === undefined ? '' : defaultValue,
      'html'
    )
  );

  const onRichTextChange = richTextValueTest => {
    setRichTextValue(richTextValueTest);
    onChange(richTextValueTest.toString('html'));
  };

  return (
    <Container center style={fullWidth ? { paddingLeft: 0, paddingRight: 0 } : {}} maxWidth="xl">
      <RichTextEditor
        value={richTextValue}
        onChange={onRichTextChange}
        rootStyle={{
          width: fullWidth ? '100%' : '80%',
          minHeight: '250px',
          marginTop: `${marginTop}px`,
          marginRight: 'auto'
        }}
      />
    </Container>
  );
};

RichTextEditorComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  marginTop: PropTypes.number
};

RichTextEditorComponent.defaultProps = {
  fullWidth: false,
  marginTop: 32
};

export default RichTextEditorComponent;
